<template>
	<div class="row no-gutters">
		<div class="col-2 top-layer" style="z-index: 9999;">
			<FormInput
				dataKey="nPeople"
				inputClass="field-icon"
				fieldWrapClass="size-big"
			>
				<template v-slot:label>Number of<br />People</template>

				<template v-slot:icon>
					<UseIcon asset="sprite.svg#icon-woman" />
				</template>

				<template v-slot:tooltip-content>
					<p>Total number of people in the building served by the domestic hot water system. Load shape based on Ecotope research. </p>

					<p>The number of people is multiplied by the gallons per person to get peak daily usage. The daily profile for this sizing methods is derived from Ecotope research.</p>
				</template>

				<template v-slot:locked-content>
					<i class="symbol help left">
						<object tabindex="-1" type="image/svg+xml" data="/static/	build/gfx/svg/symbol-lock.svg"></object>
					</i>Locked to CBECC-Res
				</template>
			</FormInput>
		</div>

		<div id="nApts" class="col-3 col-xl-2 offset-1 bottom-layer">
			<FormInput
				dataKey="nApt"
				inputClass="field-icon"
				fieldWrapClass="size-big"
			>
				<template v-slot:icon>
					<i class="icon"><svg aria-hidden="true">
						<use xlink:href="/static/build/gfx/sprite.svg#icon-apartment"></use>
					</svg></i>
				</template>
			</FormInput>
		</div>

		<div class="col-5 ml-auto mr-4 mr-xxl-0">
			<div class="field-wrap size-big">
				<label data-help="inputs-gpdpp">Peak Gallons per Day per Person</label>

				<WaterSlider
					:value="formData.gpdpp"
					:onUpdate="val => formData.gpdpp = val"
					:sliderStyles="{ marginTop: '48px', marginBottom: '28px' }"
				/>

				<div class="suffix-wrap"></div>
			</div>
		</div>
	</div>
</template>

<script>
import WaterSlider from '@/components/WaterSlider'
import UseIcon from '@/components/UseIcon'
import formData from '@/components/Sizer/form-data-store'
import FormInput from '@/components/FormInput'

export default {
	name: 'NPepInputs',

	components: {
		WaterSlider,
		FormInput,
		UseIcon,
	},

	data: () => ({
		formData,
	}),
}
</script>

<style scoped>
	#slider_gpdpp {
		z-index: 2;
	}

	.presets {
		position: absolute;
		width: 100%;
		top: 49%;
	}
</style>
